import { useState } from "react";
import img1 from "../../images/homw.png";
import img2 from "../../images/banner image/1.png";
import img3 from "../../images/banner image/2.png";
import img4 from "../../images/banner image/3.png";
import img5 from "../../images/banner image/5.png";
import { Galleria } from "primereact/galleria";

export default function ImageSlider() {
  const [position] = useState("right");

  const images = [
    {
      itemImageSrc: img1,
      thumbnailImageSrc: img1,
      alt: "Image 1",
    },
    {
      itemImageSrc: img2,
      thumbnailImageSrc: img2,
      alt: "Image 2",
    },
    {
      itemImageSrc: img3,
      thumbnailImageSrc: img3,
      alt: "Image 3",
    },
    {
      itemImageSrc: img4,
      thumbnailImageSrc: img4,
      alt: "Image 4",
    },
    {
      itemImageSrc: img5,
      thumbnailImageSrc: img5,
      alt: "Image 5",
    },
  ];

  const responsiveOptions = [
    {
      breakpoint: "991px",
      numVisible: 4,
    },
    {
      breakpoint: "767px",
      numVisible: 3,
    },
    {
      breakpoint: "575px",
      numVisible: 1,
    },
  ];

  const itemTemplate = (item) => {
    return (
      <img
        src={item.itemImageSrc}
        alt={item.alt}
        style={{ width: "100%", maxHeight: "450px", objectFit: "contain" }}
      />
    );
  };

  const thumbnailTemplate = (item) => {
    return (
      <img
        src={item.thumbnailImageSrc}
        alt={item.alt}
        style={{ width: "100%", height: "60px", objectFit: "cover" }}
      />
    );
  };

  return (
    <>
      <div style={{ marginBottom: "50px" }} className="grid gap-3 mb-5">
        <div
          className="text-left lg:col-6 sm:col-12"
          style={{ maxWidth: "500px", margin: "auto" }}>
          <h1 style={{ fontSize: "2.5rem" }}>
            <strong>
              Ride Into <span style={{ color: "#e53935" }}>Adventure</span>
            </strong>
          </h1>
          <p>Safe, stylish and super fun bikes just for your little one.</p>
          <button
            style={{
              marginTop: "1rem",
              padding: "10px 20px",
              borderRadius: "30px",
              backgroundColor: "#f06292",
              color: "white",
              border: "none",
              cursor: "pointer",
            }}>
            Explore Now →
          </button>
        </div>
        <div
          className="galleria-wrapper mt-4 lg:col-6 sm:col-12"
          style={{ maxWidth: "700px", margin: "auto" }}>
          <Galleria
            value={images}
            responsiveOptions={responsiveOptions}
            numVisible={5}
            item={itemTemplate}
            thumbnail={thumbnailTemplate}
            thumbnailsPosition={position}
            showItemNavigators
            showThumbnails={false}
            circular
            autoPlay
            transitionInterval={2000}
          />
        </div>
      </div>
    </>
  );
}
